/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { Button } from "@mui/material";
import { Image } from "@mui/icons-material";

const LinkDialogButton = (props) => {

    const setOpen = props.setOpen;
    const openLinkDialog = () => {
        setOpen(true);
    };

    return (
        <Fragment>
            <Button
                color='primary'
                variant='contained'
                onClick={openLinkDialog}
            >
                <Image style={{ marginRight: "8px" }} />
                Select Link
            </Button>
        </Fragment>
    );
};

export default LinkDialogButton;
